import JobListPage from "./JobListPage";

export { JobListPage as default };
